export type Goal = "stage" | "meetings" | "language" | "clarity";

export const GOAL_LABEL: Record<Goal, string> = {
  stage: "On stage or camera",
  meetings: "In meetings and calls",
  language: "Learning Swedish",
  clarity: "I want to stop mumbling",
};

/** Tone adapts to why someone's here — set once in onboarding, used everywhere. */
export const SESSION_INTRO: Record<Goal, string> = {
  stage: "Actors warm up before every call. Let's warm up.",
  meetings: "You've got a call today. Ninety seconds, and you're sharp.",
  language: "Five minutes in two languages. Let's train.",
  clarity: "Five minutes a day. Your mouth is a muscle — train it.",
};

export const COLD_OPEN_LINE_1 = "Your mouth is a muscle.";
export const COLD_OPEN_LINE_2 = "Five minutes a day.";
